export const filterSelectByArrays = (sourceArray: {id: string, itemName: string}[], filterBy = []) => {
  return sourceArray.filter((items) => !filterBy.includes(items.id))
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/filter-select-items.ts